import { type Common } from './common.js';
import { type EncounterProblem } from './models/problemGroup.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async exportedToEhr(encounterId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/problemGroups/exportedToEhrManually`);
    return await this.common.postJSON(url, { encounterId });
  }

  async exportToEhr(encounterId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/problemGroups/exportToEhr`);
    return await this.common.postJSON(url, { encounterId });
  }

  async findAllByEncounterId(encounterId: string): Promise<EncounterProblem[]> {
    const url = this.common.constructPath(`/problemGroups/${encounterId}`);
    return await this.common.getJSON(url);
  }
}
